module.exports = __webpack_public_path__ + "img/18.216a607a.png";